import {
  RIGHT_PANEL_TAB_CATEGORY_SPEND,
  RIGHT_PANEL_TAB_FINANCIAL,
  RIGHT_PANEL_TAB_NUTRITION,
  RIGHT_PANEL_TAB_QUANTITY,
  RIGHT_PANEL_TAB_RESISTANCE,
  SUMMARY_ENTITY_PLANT_PROTECTION,
  SUMMARY_ENTITY_PRODUCTION,
  SUMMARY_ENTITY_SOIL_INPUT,
} from 'constants/uiConstants';

import type { RightPanelTabId } from '../../redux/slices/InsightsSlice';

const SPEND_AND_QUANTITY: RightPanelTabId[] = [
  RIGHT_PANEL_TAB_CATEGORY_SPEND,
  RIGHT_PANEL_TAB_QUANTITY,
];

/** The Live totals sections that apply to each tasks grid filter. */
const TABS_BY_FILTER: Record<string, RightPanelTabId[]> = {
  [SUMMARY_ENTITY_SOIL_INPUT]: [RIGHT_PANEL_TAB_NUTRITION, ...SPEND_AND_QUANTITY],
  [SUMMARY_ENTITY_PLANT_PROTECTION]: [
    RIGHT_PANEL_TAB_RESISTANCE,
    ...SPEND_AND_QUANTITY,
  ],
  [SUMMARY_ENTITY_PRODUCTION]: [RIGHT_PANEL_TAB_FINANCIAL],
};

/**
 * Whether a Live totals section shows while the tasks grid is filtered: only
 * the ones that answer something about that category — Soil input: Nutrient
 * balance; Plant protection: Resistance; Production: Financial risk; every
 * other category: Category spend and Quantity required (which the first two
 * also keep). With no filter every section shows. Only what's on screen
 * changes — each section's pinned / collapsed state is kept.
 */
export const isTabShownForGridFilter = (
  tabId: RightPanelTabId,
  categoryKey: string | null
): boolean =>
  !categoryKey ||
  (TABS_BY_FILTER[categoryKey] ?? SPEND_AND_QUANTITY).includes(tabId);
